
// ========================================
// FIRST & TENDER - CART UPSELL
// Shopify Horizon
// Dinamik beden, renk, fiyat ve gorsel
// ========================================

// Urun varyantlarini oku
function ftGetVariants(card) {
  try {
    const json = card.querySelector(
      '.ft-upsell__variants'
    );

    return JSON.parse(json?.textContent || '[]');
  } catch (error) {
    console.error('FT varyant verisi okunamadi:', error);
    return [];
  }
}

// Secilen varyanti guncelle
function ftUpdateVariant(card, changedIndex = null) {
  if (!card) return;

  const variants = ftGetVariants(card);

  const selects = [
    ...card.querySelectorAll(
      '[data-ft-option-index]'
    )
  ];

  const button = card.querySelector(
    '[data-ft-upsell-add]'
  );

  const price = card.querySelector(
    '[data-ft-price]'
  );

  const image = card.querySelector(
    '[data-ft-variant-image]'
  );

  const status = card.querySelector(
    '.ft-upsell__status'
  );

  if (!button) return;

  // Stokta olmayan secenekleri kontrol et
  selects.forEach((select, index) => {
    [...select.options].forEach((option) => {
      option.disabled = !variants.some(
        (variant) =>
          variant.available &&
          variant.options[index] === option.value
      );
    });
  });

  const selectedOptions = selects.map(
    (select) => select.value
  );

  // Secilen beden/renk kombinasyonunu bul
  let selectedVariant = variants.find(
    (variant) =>
      variant.options.length === selectedOptions.length &&
      variant.options.every(
        (value, index) =>
          value === selectedOptions[index]
      )
  );

  // Kombinasyon yoksa secilen son secenegi
  // koruyarak stoktaki uygun varyanti sec
  if (
    changedIndex !== null &&
    (!selectedVariant || !selectedVariant.available)
  ) {
    const alternative = variants.find(
      (variant) =>
        variant.available &&
        variant.options[changedIndex] ===
          selects[changedIndex]?.value
    );

    if (alternative) {
      selectedVariant = alternative;

      selects.forEach((select, index) => {
        select.value = alternative.options[index];
      });
    }
  }

  // Varyant bulunamadi
  if (!selectedVariant) {
    button.disabled = true;
    button.textContent = 'Mevcut Değil';

    delete button.dataset.ftUpsellVariant;

    if (price) {
      price.textContent = '—';
    }

    if (status) {
      status.textContent =
        'Bu beden ve renk kombinasyonu mevcut değil.';
    }

    return;
  }

  // FIYATI GUNCELLE
  if (price) {
    price.textContent = selectedVariant.price;
  }

  // =====================================
  // GORSELI GUNCELLE - YENI OZELLIK
  // =====================================

  if (image && selectedVariant.image) {

    const newImageUrl = selectedVariant.image;

    // Gorsel farkliysa degistir
    if (image.getAttribute('src') !== newImageUrl) {
      image.src = newImageUrl;
    }

    image.alt =
      selectedVariant.imageAlt ||
      'Seçilen ürün varyantı';
  }

  // =====================================
  // STOK KONTROLU
  // =====================================

  if (!selectedVariant.available) {
    button.disabled = true;
    button.textContent = 'Stokta Yok';

    delete button.dataset.ftUpsellVariant;

    if (status) {
      status.textContent =
        'Seçilen ürün şu anda stokta yok.';
    }

    return;
  }

  // GUNCEL VARYANTI BUTONA ATA
  button.disabled = false;
  button.textContent = '+ Ekle';

  button.dataset.ftUpsellVariant = String(
    selectedVariant.id
  );

  button.dataset.ftUpsellQuantity = String(
    selectedVariant.quantity || 1
  );

  if (status) {
    status.textContent = '';
  }
}

// Ilk yukleme
function ftInitUpsell() {
  document
    .querySelectorAll('[data-ft-upsell-product]')
    .forEach((card) => {
      ftUpdateVariant(card);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    ftInitUpsell,
    { once: true }
  );
} else {
  ftInitUpsell();
}

// BEDEN / RENK DEGISIMI
document.addEventListener('change', (event) => {
  const target = event.target;

  if (
    !(target instanceof HTMLSelectElement) ||
    !target.matches('.ft-upsell__select')
  ) {
    return;
  }

  const card = target.closest(
    '[data-ft-upsell-product]'
  );

  const changedIndex = Number(
    target.dataset.ftOptionIndex
  );

  ftUpdateVariant(card, changedIndex);
});

// ========================================
// SEPETE EKLEME
// ========================================

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(
    '[data-ft-upsell-add]'
  );

  if (!button || button.disabled) return;

  const card = button.closest(
    '[data-ft-upsell-product]'
  );

  if (!card) return;

  // Secilen varyanti tekrar kontrol et
  ftUpdateVariant(card);

  if (button.disabled) return;

  const variantId = button.dataset.ftUpsellVariant;

  const quantity = Number(
    button.dataset.ftUpsellQuantity || 1
  );

  const status = card.querySelector(
    '.ft-upsell__status'
  );

  if (!variantId) return;

  button.disabled = true;
  button.textContent = 'Ekleniyor...';

  if (status) {
    status.textContent = '';
  }

  try {
    if (!window.Shopify?.actions?.updateCart) {
      throw new Error(
        'Sepet servisine ulaşılamadı.'
      );
    }

    const result = await Shopify.actions.updateCart(
      {
        lines: [
          {
            merchandiseId:
              `gid://shopify/ProductVariant/${variantId}`,
            quantity: quantity
          }
        ]
      },
      {
        event: {
          context: 'cart',
          detail: {
            source: 'ft-cart-upsell'
          }
        }
      }
    );

    if (result?.userErrors?.length) {
      throw new Error(
        result.userErrors[0].message
      );
    }

    if (status?.isConnected) {
      status.textContent = result?.warnings?.length
        ? result.warnings[0].message
        : 'Ürün sepete eklendi.';
    }

  } catch (error) {
    console.error('FT Sepet Hatasi:', error);

    if (status?.isConnected) {
      status.textContent =
        error.message ||
        'Ürün eklenirken hata oluştu.';
    }

  } finally {
    if (button.isConnected) {
      button.disabled = false;
      button.textContent = '+ Ekle';
    }
  }
});
